// extracted by mini-css-extract-plugin
export default {"container":"Categoria_container__GjaSm","videoBox":"Categoria_videoBox__jZfGi"};